import React, { useContext, useState } from "react";
import { Grid, TextareaAutosize, Typography } from "@material-ui/core";
import RecurrentPaymentContext from "../../../../../infrastructure/Contexts/components/data/RecurrentPaymentsWrapper/context";
import RecurrentPaymentActions from "../../../../../infrastructure/Contexts/components/actions/RecurrentPaymentActionsWrapper/context";
import CobeeCheckbox from "../../../CobeeCheckbox";
import CobeeButton from "../../../CobeeButton";
import { translate as t } from "../../../../../infrastructure/translate/localization";
import useStyles from "./styles";

export default function RejectEducationModal(): JSX.Element {
  const [isCheckedFirst, setIsCheckedFirst] = useState<boolean>(false);
  const [isCheckedSecond, setIsCheckedSecond] = useState<boolean>(false);
  const [isOtherChecked, setIsOtherChecked] = useState<boolean>(false);
  const [reasonChecked, setReasonChecked] = useState<string>("");
  const [otherReason, setOtherReason] = useState<string>("");

  const { subTitle, reasonText, checkboxContainer, textArea, containerButton } =
    useStyles();
  const { recurrentPaymentDetail } = useContext(RecurrentPaymentContext);
  const { rejectEducation, rejectEducationIsLoading } = useContext(
    RecurrentPaymentActions
  );
  const { employee, id, category } = recurrentPaymentDetail;

  const firstReason = t(
    "recurrent-payments-section.the-course-does-not-match-the-performance-of-the-job-position"
  );

  const secondReason = t("recurrent-payments-section.the-amount-is-too-high");

  const handleCheck = (option) => {
    if (option === "first") {
      setReasonChecked(firstReason);
      setIsCheckedFirst((prev) => !prev);
      setIsCheckedSecond(false);
      setIsOtherChecked(false);
    } else if (option === "second") {
      setReasonChecked(secondReason);
      setIsCheckedFirst(false);
      setIsCheckedSecond((prev) => !prev);
      setIsOtherChecked(false);
    } else {
      setIsCheckedFirst(false);
      setIsCheckedSecond(false);
      setIsOtherChecked((prev) => !prev);
    }
  };

  const shouldDisableButton =
    (!isCheckedFirst && !isCheckedSecond && !isOtherChecked) ||
    (isOtherChecked && otherReason === "");

  return (
    <Grid>
      <Typography variant="body2" className={subTitle}>{`${t(
        "recurrent-payments-section.choose-a-reason-for-rejecting-this-formation-of"
      )} ${employee.name} ${employee.surname}`}</Typography>
      <Grid container alignItems="center">
        <CobeeCheckbox
          checked={isCheckedFirst}
          className={checkboxContainer}
          onChange={() => handleCheck("first")}
        />
        <Typography variant="body2" className={reasonText}>
          {firstReason}
        </Typography>
      </Grid>
      <Grid container alignItems="center">
        <CobeeCheckbox
          checked={isCheckedSecond}
          className={checkboxContainer}
          onChange={() => handleCheck("second")}
        />
        <Typography variant="body2" className={reasonText}>
          {secondReason}
        </Typography>
      </Grid>
      <Grid container alignItems="center">
        <CobeeCheckbox
          checked={isOtherChecked}
          className={checkboxContainer}
          onChange={() => handleCheck("other")}
        />
        <Typography variant="body2" className={reasonText}>
          {t("common-messages.other")}
        </Typography>
      </Grid>
      {isOtherChecked && (
        <TextareaAutosize
          value={otherReason}
          onChange={(e) => setOtherReason(e.target.value)}
          className={textArea}
          placeholder={t("common-messages.write-the-reason")}
        />
      )}
      <Grid container justifyContent="flex-end" className={containerButton}>
        <CobeeButton
          disabled={shouldDisableButton}
          isLoading={rejectEducationIsLoading}
          onClick={() => {
            rejectEducation({
              requestId: id,
              rejectedReason: isOtherChecked ? otherReason : reasonChecked,
              category,
            });
          }}
        >
          {t("actions.reject-request")}
        </CobeeButton>
      </Grid>
    </Grid>
  );
}
